import React from 'react';

const CSScolored = ({ className = '' }) => {
  return (
    <svg className={className} width="46" height="54" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#264DE4"
          d="M45.86 0l-4.1779639 48.5943556L22.9019328 54 4.1735389 48.601969 0 0z"
        />
        <path fill="#2965F1" d="M37.7801404 45.4313575L41.274 3.46153846H22.93V49.8461538z" />
        <path
          fill="#EBEBEB"
          d="M9.82714286 21.4615385l.50457594 6.2307692H22.93v-6.2307692zM22.93 9.69230769H8.51685714l.52251251 6.23076921H22.93zM22.93 43.6075295v-6.3986926l-.0248727.007178-6.3211606-1.8494803-.4040873-4.9049961H10.4822857l.7951759 9.6565461 11.6264158 3.4973z"
        />
        <path
          fill="#FFF"
          d="M30.0150618 27.8091543l-.6678594 7.7698662L22.93 37.3824991v6.2328855l11.795428-3.4039175.0865392-1.0121644 1.3520636-15.7723244.1403886-1.6087505 1.0387235-12.12592011H22.93v5.99105841h8.1075671l-.523543 6.1348617H22.93v5.9909265z"
        />
      </g>
    </svg>
  );
};
export default CSScolored;
